module.exports = __webpack_public_path__ + "img/3.34e3fbd7.png";